export default "__VITE_ASSET__BE0lfVur__"